//
// This is only used for for checking
// data mismatch between extras and order.
//
import { UIProductSelection } from "@flights/types";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getSelectedExtraProducts } from "../ancillaries/store/extraProducts/selectors";
import { getFlight } from "../store/flightDetails/selectors";
import { getOrder } from "../store/order/selectors";
import { offerExtraProduct } from "../utils/checkoutOfferPersistedStore";
import useEvents from "./useEvents";
import { grumble } from "../utils/flog";

const useCheckPersistedSelectedAncillaries = () => {
  const flight = useSelector(getFlight);
  const order = useSelector(getOrder);
  const extras = useSelector(getSelectedExtraProducts);
  const { jsError } = useEvents();
  const [hasTracked, setHasTracked] = useState(false);

  useEffect(() => {
    if (hasTracked) return;
    if (!flight?.token || !order || !Object.keys(extras).length) return;

    const persistedOfferData = offerExtraProduct.get(flight.token);
    const persistedAncillaries = persistedOfferData?.ancillaries;
    const orderAncillaries = order.ancillaries;

    if (persistedAncillaries && orderAncillaries && extras) {
      const persistedAncillariesKeys = Object.keys(persistedAncillaries).filter(
        (a: keyof UIProductSelection) => (persistedAncillaries[a]?.length || 0) > 0
      );
      const matchExtras = persistedAncillariesKeys.every((a: keyof UIProductSelection) => extras[a]);
      const matchOrder = persistedAncillariesKeys
        .map((a: keyof UIProductSelection) => {
          return a === "specialBags"
            ? "specialBag"
            : a === "mealPreference"
            ? "mealChoice"
            : a === "seatMap"
            ? "seatMapSelection"
            : a;
        })
        .every((a) => orderAncillaries[a]);

      if (!matchExtras || !matchOrder) {
        jsError(new Error("Persisted ancillaries data does not match offer."));
        grumble("Persisted ancillaries data does not match offer.", {
          persistedStore: Object.keys(persistedAncillaries),
          extrasReduxStore: Object.keys(extras),
          orderReduxStore: Object.keys(orderAncillaries)
        });
        setHasTracked(true);
      }
    }
  }, [extras, flight?.token, hasTracked, jsError, order]);
};

export default useCheckPersistedSelectedAncillaries;
